const zip = zip => !zip || zip.length > 0

export default zip
